<template>
  <div class="customer-invoice">
    <div v-if="!enable_payments_v2" class="customer-invoice__date">
      {{ pretty_date }}
    </div>

    <div class="customer-invoice__name">
      <div>
        {{ pretty_name }}
        <div class="customer-invoice__date">
          {{ pretty_date }}
        </div>
      </div>
    </div>

    <div class="customer-invoice__notes">
      {{ invoice.notes }}
    </div>

    <invoice-status-pill v-if="enable_drafts" :invoice="invoice"></invoice-status-pill>

    <div class="flex-fill"></div>

    <div>
      <div v-if="enable_payments_v2" class="customer-invoice__icon" @click="$emit('edit', invoice)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
          <path
            d="M10.0995 2.37843C11.1844 2.37811 12.2358 2.7563 13.0747 3.44855C13.9135 4.1408 14.4878 5.10429 14.6998 6.17483C14.9117 7.24538 14.7482 8.35676 14.237 9.31959C13.7259 10.2824 12.8988 11.0372 11.8966 11.4552C10.8944 11.8732 9.77915 11.9286 8.74089 11.612C7.70262 11.2955 6.80558 10.6265 6.2026 9.719C5.59962 8.81155 5.32801 7.7218 5.43405 6.63545C5.54009 5.54909 6.01722 4.53334 6.78415 3.76126C7.21928 3.32279 7.73608 2.97496 8.30497 2.73767C8.87386 2.50039 9.48367 2.37831 10.0995 2.37843ZM10.0995 0.200001C3.83329 0.200001 0.199951 5.37494 0.199951 7.10113C0.199951 8.82731 3.83329 14 10.0995 14C16.3657 14 20 8.82776 20 7.10113C20 5.37449 16.368 0.200001 10.0995 0.200001Z"
            fill="#A6AAB4" />
          <path
            d="M13.0096 7.10112C13.0094 7.78539 12.7726 8.44826 12.3397 8.97599C11.9068 9.50372 11.3048 9.86341 10.6371 9.99333C9.96945 10.1233 9.27763 10.0153 8.68039 9.68804C8.08316 9.36076 7.61775 8.83454 7.36403 8.19968C7.11031 7.56483 7.0841 6.86091 7.28989 6.20873C7.49568 5.55655 7.92064 4.99676 8.49185 4.62543C9.06307 4.25409 9.74492 4.09436 10.4204 4.17365C11.0959 4.25293 11.7229 4.56629 12.1938 5.05995L10.0838 7.10157H13.0118L13.0096 7.10112Z"
            fill="#A6AAB4" />
        </svg>
      </div>
    </div>

    <div @click="sendMail" class="customer-invoice__icon" data-toggle="tooltip" data-placement="top"
      title="Enviar por correo">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.26587 13.1475C1.52099 13.2716 1.80055 13.336 2.08376 13.336H15.9161C16.1207 13.3359 16.3239 13.3022 16.5178 13.2362L11.0625 7.47916C10.7784 7.75636 10.5245 7.9999 10.3125 8.20384C9.96197 8.54211 9.4956 8.73091 9.01054 8.73091C8.52547 8.73091 8.0591 8.54211 7.70854 8.20384C7.45736 7.96189 7.14614 7.66053 6.79528 7.32037L1.26587 13.1475Z"
          fill="#A6AAB4" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M17.3675 1.35344C16.5657 2.13474 13.9362 4.69092 11.9661 6.60123L17.5096 12.449C17.6993 12.1455 17.8 11.794 17.8 11.4352V2.5648C17.7999 2.12254 17.647 1.69416 17.3675 1.35344Z"
          fill="#A6AAB4" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.640687 1.34275C0.355946 1.68514 0.199895 2.11783 0.199951 2.5648V11.4352C0.199985 11.7162 0.261776 11.9938 0.380877 12.2478L5.88752 6.44243C3.96092 4.57292 1.47938 2.1589 0.640687 1.34275Z"
          fill="#A6AAB4" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.7793 0.688949L8.57479 7.28829C8.69163 7.40097 8.84703 7.46385 9.00866 7.46385C9.17028 7.46385 9.32569 7.40097 9.44253 7.28829C11.0037 5.78151 14.8554 2.03693 16.238 0.692117C16.1318 0.673389 16.0241 0.663982 15.9162 0.664001H2.08385C1.98183 0.664127 1.87999 0.672469 1.7793 0.688949Z"
          fill="#A6AAB4" />
      </svg>
    </div>

    <div>
      <a class="customer-invoice__icon" :href="invoice_pdf_link" target="_blank" data-toggle="tooltip"
        data-placement="top" title="Imprimir">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.75 7.75V3.71582C16.75 3.41734 16.6315 3.13152 16.4206 2.92023L14.8294 1.32941C14.6185 1.11848 14.3323 1 14.0338 1H4.375C3.75379 1 3.25 1.50379 3.25 2.125V7.75C2.00723 7.75 1 8.75723 1 10V13.9375C1 14.2483 1.25172 14.5 1.5625 14.5H3.25V17.875C3.25 18.4962 3.75379 19 4.375 19H15.625C16.2462 19 16.75 18.4962 16.75 17.875V14.5H18.4375C18.7483 14.5 19 14.2483 19 13.9375V10C19 8.75723 17.9928 7.75 16.75 7.75ZM14.5 16.75H5.5V13.375H14.5V16.75ZM14.5 8.875H5.5V3.25H12.25V4.9375C12.25 5.24828 12.5017 5.5 12.8125 5.5H14.5V8.875ZM16.1875 11.4062C15.7217 11.4062 15.3438 11.0283 15.3438 10.5625C15.3438 10.0963 15.7217 9.71875 16.1875 9.71875C16.6533 9.71875 17.0312 10.0963 17.0312 10.5625C17.0312 11.0283 16.6533 11.4062 16.1875 11.4062Z"
            fill="#A6AAB4" />
        </svg>
      </a>
    </div>

    <div v-if="enable_simple_invoices">
      <a class="customer-invoice__icon" :href="invoice_simple_pdf_link" target="_blank" data-toggle="tooltip"
        data-placement="top" title="Imprimir Simplificada">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M16.75 7.75V3.71582C16.75 3.41734 16.6315 3.13152 16.4206 2.92023L14.8294 1.32941C14.6185 1.11848 14.3323 1 14.0338 1H4.375C3.75379 1 3.25 1.50379 3.25 2.125V7.75C2.00723 7.75 1 8.75723 1 10V13.9375C1 14.2483 1.25172 14.5 1.5625 14.5H3.25V17.875C3.25 18.4962 3.75379 19 4.375 19H15.625C16.2462 19 16.75 18.4962 16.75 17.875V14.5H18.4375C18.7483 14.5 19 14.2483 19 13.9375V10C19 8.75723 17.9928 7.75 16.75 7.75ZM14.5 16.75H5.5V13.375H14.5V16.75ZM14.5 8.875H5.5V3.25H12.25V4.9375C12.25 5.24828 12.5017 5.5 12.8125 5.5H14.5V8.875ZM16.1875 11.4062C15.7217 11.4062 15.3438 11.0283 15.3438 10.5625C15.3438 10.0963 15.7217 9.71875 16.1875 9.71875C16.6533 9.71875 17.0312 10.0963 17.0312 10.5625C17.0312 11.0283 16.6533 11.4062 16.1875 11.4062Z"
            fill="#A6AAB4" />
        </svg>
      </a>
    </div>

    <div class="customer-invoice__total">{{ pretty_total }}</div>
  </div>
</template>

<script>
export default {
  props: ["invoice", "customer"],
  data() {
    return {
      sending: false,
    };
  },
  computed: {
    enable_simple_invoices() {
      return this.clinic && this.clinic.config["enable_simple_invoices"];
    },
    invoice_pdf_link() {
      return `/invoice/${this.invoice.id}/pdf`;
    },
    invoice_simple_pdf_link() {
      return `/invoice/${this.invoice.id}/pdf?type=simple`;
    },
    pretty_date() {
      return moment(this.invoice.created_at).toDate().toLocaleDateString();
    },
    pretty_name() {
      let code = this.invoice.code || ('BORR' + this.invoice.id);
      let ret = `Factura ${code}`;

      if (this.invoice.is_downpayment) {
        ret = ret + "- Anticipo ";
      }

      if (this.invoice.is_revocation) {
        ret = ret + "- Rectificación ";
      } else {
        if (this.invoice.is_paid) {
          if (this.invoice.paid_amount - this.invoice.total_amount > 0.5) {
            ret = ret + "- Pagada ";
          } else {
            ret = ret + "- Pagada ";
          }
        } else {
          ret = ret + "- Sin pagar ";
        }

        if (this.invoice.revocation_invoice_id) {
          ret = ret + "- Rectificada ";
        }
      }

      return ret;
    },
    pretty_total() {
      let value = this.invoice.invoicelines.reduce((total, line) => {
        return (
          total +
          Number(line.price) *
          Number(line.quantity) *
          (1 - Number(line.discount) / 100) -
          line.abs_discount
        );
      }, 0);
      return WabiDent.fmtMoney(value, 0);
    },
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    enable_drafts() {
      if (!this.clinic) return false;
      return this.clinic.config.invoices_enable_drafts;
    },
    ...mapGetters(["msgwindow", "clinic"]),
  },
  methods: {
    sendMail() {
      if (this.sending) return;
      this.sending = true;
      this.msgwindow.info("Enviando factura ...");
      axios
        .get(`/invoice/${this.invoice.id}/email`)
        .then((response) => {
          let data = response.data;
          if (data.error) {
            this.msgwindow.error(data.message);
          } else {
            this.msgwindow.success(data.message);
          }
        })
        .catch((error) => {
          console.log("[ERR] sendInvoiceEmail ", error);
          this.msgwindow.error("Error enviando factura !");
        })
        .then(() => {
          this.sending = false;
        });
    },
  },
};
</script>

<style lang="scss">
.customer-invoice {
  padding: 15px 20px;
  border-radius: 5px;
  background: var(--ui-gris-medio, #f9f9f8);
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;

  .fcenter {
    justify-content: center;
  }

  &__date {
    font-size: 14px;
    color: #a0a4b0;
    margin-right: 10px;
    font-weight: bold;
  }

  &__name {
    font-size: 16px;
    margin-right: 15px;
    font-weight: bold;
  }

  &__notes {
    font-size: 12px;
    font-weight: 500;
    min-height: 6ch;
  }

  &__total {
    font-size: 20px;
    color: var(--theme-text);
    flex: 0 0 100px;
    font-weight: bold;
    text-align: right;
  }

  &__icon {
    text-decoration: none;
    cursor: pointer;
    color: var(--theme-grey);
    margin: 6.5px;

    svg>* {
      fill: currentColor;
      transition: 0.3s;
    }

    &:hover {
      color: var(--theme-color);
    }
  }

  &__email,
  &__print {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    flex: 0 0 35px;
    cursor: pointer;
    transition: all 0.2s;

    a {
      color: inherit;
      text-decoration: none;
    }

    i {
      font-size: 24px;
    }

    &.done {
      color: var(--theme-color-attended);
    }

    &:hover {
      color: var(--theme-color);
    }
  }
}
</style>
